import { Component, Input, OnChanges } from '@angular/core';
import { ITraveller } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { TravellerDataTranslationService } from "libraries/service/traveller-data-translation/traveller-data-translation.service";

@Component({
    selector: 'sector-traveller',
    template: `
        <div class="traveller-container">
            <strong>{{ travellerIdentity }}</strong> {{ travellerType }}
        </div>
    `
})
export class SectorTravellerComponent implements OnChanges{

    public travellerIdentity: string;
    public travellerType: string;

    @Input()
    public travellerData: ITraveller;

    @Input()
    public abbreviateType: boolean = false;

    constructor(
        private readonly travellerDataTranslationService: TravellerDataTranslationService,
    ){}

    public ngOnChanges(): void{
        if(this.travellerData){
            this.init();
        }
    }

    public init(): void{
        this.travellerIdentity = this.getTravellerIdentity();
        this.travellerType = this.getTravellerType();
    }

    private getTravellerIdentity(): string{
        return this.travellerDataTranslationService.getTravellerIdentity(this.travellerData);
    }

    private getTravellerType(): string{
        const translatedType: string = this.travellerDataTranslationService.translateType(this.travellerData.xType, this.abbreviateType);
        return `(${translatedType})`;
    }
}
